module.exports = __webpack_public_path__ + "img/chuanqi3.5c2003f0.png";